import React from 'react';
import { CasinoBannersState } from './CasinoBanners.state';
import { TabItem, TabsWrapper } from 'src/domains/layouts/shared/tabs/Tabs.style';

interface PropsTypes {
    casinoBannersState: CasinoBannersState
}

export const CasinoBannersNav = ({casinoBannersState}: PropsTypes): JSX.Element => {
    return (
        <TabsWrapper>
            <TabItem isActive={casinoBannersState.collection === 'casino'} onClick={(): void => casinoBannersState.onChangeCollection('casino')}>Casino</TabItem>
            <TabItem isActive={casinoBannersState.collection === 'live-casino'} onClick={(): void => casinoBannersState.onChangeCollection('live-casino')}>Live Casino</TabItem>
        </TabsWrapper>
    );
};
